// import React, { useEffect, useState } from 'react'
// import Layout from '../components/Layout/Layout'
// import { useAuth } from '../context/auth'
// import axios from 'axios';
// // import 'antd/dist/antd.css';
// // import {Checkbox} from 'antd'
// // import 'antd/dist/antd.css'; 
// import 'antd/dist/reset.css'
// import { Prices } from "../components/Prices";
// import { Checkbox, Radio } from 'antd';
// const HomePage = () => {
//     const [products, setProducts] = useState([]);
//     const [categories, setCategories] = useState([]);
//     const [checked, setChecked] = useState([]);
//     const [radio, setRadio] = useState([]);
//     const [total, setTotal] = useState(0);
//     const [page, setPage] = useState(1);
//     const [loading, setLoading] = useState(false);


// //get all category
// const getAllCategory = async () => {
//     try {
//       const { data } = await axios.get("https://bablu-server.onrender.com/api/get-category");
//       if (data?.success) {
//         setCategories(data?.category);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     getAllCategory();
//   }, []);
//     // get all Product
//     const getAllProducts = async ()=>{
//         try {
//             const {data} = await axios.get('https://bablu-server.onrender.com/api/get-product');
//             setProducts(data?.products);
//         } catch (error) {
//             console.log(error)
//         }
//     }

//     useEffect(()=>{
//         getAllProducts();
//     })

    
//   //getTOtal COunt
//   const getTotal = async () => {
//     try {
//       const { data } = await axios.get("https://bablu-server.onrender.com/api/product-count");
//       setTotal(data?.total);
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     if (page === 1) return;
//     loadMore();
//   }, [page]);
//   //load more
//   const loadMore = async () => {
//     try {
//       setLoading(true);
//       const { data } = await axios.get(`https://bablu-server.onrender.com/api/product-list/${page}`);
//       setLoading(false);
//       setProducts([...products, ...data?.products]);
//     } catch (error) {
//       console.log(error);
//       setLoading(false);
//     }
//   };

//   // filter by cat
//   const handleFilter = (value, id) => {
//     let all = [...checked];
//     if (value) {
//       all.push(id);
//     } else {
//       all = all.filter((c) => c !== id);
//     }
//     setChecked(all);
//   };
//   useEffect(() => {
//     if (!checked.length || !radio.length) getAllProducts();
//   }, [checked.length, radio.length]);

//   useEffect(() => {
//     if (checked.length || radio.length) filterProduct();
//   }, [checked, radio]);

//   //get filterd product
//   const filterProduct = async () => {
//     try {
//       const { data } = await axios.post("https://bablu-server.onrender.com/api/product-filters", {
//         checked,
//         radio,
//       });
//       setProducts(data?.products);
//     } catch (error) {
//       console.log(error);
//     }
//   };
//     return (
//         <Layout>

//             <div className="row mt-4">
//                 <div className="col-md-3 ">
//                     <h6 className="text-center">Filter by Category</h6>
//                     <div className="d-flex flex-column">
//                     {categories?.map((c)=>(
//                         <Checkbox onChange={(e) => handleFilter(e.target.checked, c._id)}>
//                             {c.name}
//                         </Checkbox>
//                     ))}
//                     {categories?.map((c)=>(
//                         <div className="form-check">
//                             <input className="form-check-input" type="checkbox" defaultValue id="flexCheckDefault" onChange={(e) => handleFilter(e.target.checked, c._id)} />
//                             <label className="form-check-label" htmlFor="flexCheckDefault">
//                                 {c.name}
//                             </label>
//                         </div>
//                     ))}
//                     </div>
//                    <div className="d-flex flex-column" >
                    // {Prices?.map((p)=>(
                    //         <div className="form-check" onChange={(e) => setRadio(e.target.value)}>
                    //         <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" value={p.array} key={p._id} onChange={(e) => setRadio(e.target.value)}/>
                    //         <label className="form-check-label" htmlFor="flexRadioDefault1">
                    //         {p.name}
                    //         </label>
                    //        </div>
                    // ))}
                        
//                         {/* <Radio.Group onChange={(e) => setRadio(e.target.value)}>
//               {Prices?.map((p) => (
//                 <div key={p._id}>
//                   <Radio value={p.array}>{p.name}</Radio>
//                 </div>
//               ))}
//             </Radio.Group> */}
//                    </div>
//                 </div>
//                 {/* <div className="col-md-9">
//                     <h5 className='text-center'>All products</h5>
//                     <div className="d-flex flex-wrap">
//                         <h4>Products</h4>
//                         {products?.map((p) => (
//                 <div className="card m-2" style={{ width: "18rem" }}>
//                   <img
//                     src={`https://bablu-server.onrender.com/api/product-photo/${p._id}`}
//                     className="card-img-top"
//                     alt={p.name}
//                     height="250px"
//                     width="200px"
//                   />
//                   <div className="card-body">
//                     <h5 className="card-title">{p.name}</h5>
//                     <p className="card-text">{p.description}</p>
//                     <button className="btn btn-primary ms-1">More Details</button>
//                     <button className="btn btn-primary ms-1">Add to cart</button>
//                   </div>
//                 </div>
//             ))}
//                     </div>
//                 </div>
//             </div>
//         </Layout>
//     )
// }

// export default HomePage */}

// <div className="col-md-9">
//           <h1 className="text-center">All Products</h1>
//           <div className="d-flex flex-wrap">
//             {products?.map((p) => (
//               <div className="card m-2" style={{ width: "18rem" }}>
//                 <img
//                   src={`https://bablu-server.onrender.com/api/product-photo/${p._id}`}
//                   className="card-img-top"
//                   alt={p.name}
//                 />
//                 <div className="card-body">
//                   <h5 className="card-title">{p.name}</h5>
//                   <p className="card-text">
//                     {p.description.substring(0, 30)}...
//                   </p>
//                   <p className="card-text"> $ {p.price}</p>
//                   <button class="btn btn-primary ms-1">More Details</button>
//                   <button class="btn btn-secondary ms-1">ADD TO CART</button>
//                 </div>
//               </div>
//             ))}
//           </div>
//           <div className="m-2 p-3">
//             {products && products.length < total && (
//               <button
//                 className="btn btn-warning"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   setPage(page + 1);
//                 }}
//               >
//                 {loading ? "Loading ..." : "Loadmore"}
//               </button>
//             )}
//           </div>
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default HomePage;

import React, { useState, useEffect } from "react";
import Layout from "./../components/Layout/Layout";

import axios from "axios";
import { Checkbox, Radio } from "antd";
import { Prices } from "../components/Prices";
import SearchInput from "../components/Form/SearchInput";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/cart";
import { toast } from "react-hot-toast";
import bablu_shop1 from '../assets/bablu_shop1.jpg';
import bablu_shop2 from '../assets/bablu_shop2.jpg';
const HomePage = () => {
  const [cart, setCart] = useCart();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [checked, setChecked] = useState([]);
  const [radio, setRadio] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [filterCategory, setFilterCategories] = useState(false);
  const [filterprice, setFilterPrice] = useState(false);
const navigate = useNavigate()

const handleButtonFilterCategory=()=>{
setFilterCategories(!filterCategory);
}
const handleButtonFilterPrice=()=>{
setFilterPrice(!filterprice);
}
  //get all cat
  const getAllCategory = async () => {
    try {
      const { data } = await axios.get("https://bablu-server.onrender.com/api/get-category");
      if (data?.success) {
        setCategories(data?.category);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCategory();
    getTotal();
  }, []);
  //get products
  const getAllProducts = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`https://bablu-server.onrender.com/api/product-list/${page}`);
      setLoading(false);
      setProducts(data.products);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  //getTOtal COunt
  const getTotal = async () => {
    try {
      const { data } = await axios.get("https://bablu-server.onrender.com/api/product-count");
      setTotal(data?.total);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (page === 1) return;
    loadMore();
  }, [page]);
  //load more
  const loadMore = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`https://bablu-server.onrender.com/api/product-list/${page}`);
      setLoading(false);
      setProducts([...products, ...data?.products]);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  // filter by cat
  const handleFilter = (value, id) => {
    let all = [...checked];
    if (value) {
      all.push(id);
    } else {
      all = all.filter((c) => c !== id);
    }
    setChecked(all);
  };
  useEffect(() => {
    if (!checked.length || !radio.length) getAllProducts();
  }, [checked.length, radio.length]);

  useEffect(() => {
    if (checked.length || radio.length) filterProduct();
  }, [checked, radio]);

  //get filterd product
  const filterProduct = async () => {
    try {
      const { data } = await axios.post("https://bablu-server.onrender.com/api/product-filters", {
        checked,
        radio,
      });
      setProducts(data?.products);
    } catch (error) {
      console.log(error);
    }
  };
  // const images = [
  //   '../assets/bablu_shop1.jpg',
  //   'https://img.freepik.com/premium-vector/modern-flat-people-business-m-commerce-easy-use-highly-customizable_115990-371.jpg?size=626&ext=jpg&ga=GA1.2.158250536.1676270683&semt=ais',
  //   'https://img.freepik.com/free-vector/online-shopping-concept-landing-page_23-2148253518.jpg?size=626&ext=jpg&ga=GA1.2.158250536.1676270683&semt=ais',
  //   // Add more image URLs as needed
  // ];

  return (
    <Layout title={"ALl Products - Best offers "}>
<div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
  <div className="carousel-inner">
    <div className="carousel-item active" style={{height:'250px'}}>
      <img className="d-block h-30 w-100" src={bablu_shop1} alt="First slide" />
    </div>
    <div className="carousel-item">
      <img className="d-block h-30 w-100" src={bablu_shop2} alt="Second slide" style={{height:'300px'}} />
    </div>
    <div className="carousel-item">
      <img className="d-block h-30 w-100" src="https://img.freepik.com/free-vector/online-shopping-concept-landing-page_23-2148253518.jpg?size=626&ext=jpg&ga=GA1.2.158250536.1676270683&semt=ais" alt="Third slide" style={{height:'300px'}}/>
    </div>
  </div>
  <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true" />
    <span className="sr-only">Previous</span>
  </a>
  <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
    <span className="carousel-control-next-icon" aria-hidden="true" />
    <span className="sr-only">Next</span>
  </a>
</div>
<div className="container-fluid">
{/* <div className="carousel d-flex"style={{justifyContent:'center',alignItems:'center'}} >
      <button className="carousel-button" onClick={handlePrev}style={{height:'20px', width:'20px', background:'transparent', border:'none'}}>˂</button>
      <img src={images[currentIndex]} alt="carousel item"  height='250px' width='85%' style={{margin:'5px'}}/>
      <button className="carousel-button" onClick={handleNext} style={{height:'20px', width:'20px',background:'transparent', border:'none'}}>˃</button>
    </div> */}

      <div className="container mt-4 w-80" style={{marginLeft:'-10px'}}>
        <SearchInput/>
      </div>
      <div className="row mt-3">
        <div className="col-12 col-sm-2 col-md-3 col-lg-2">
          <div className="d-flex flex-row">
            <div className="btn btn-outline-primary ms-2 btn-sm" onClick={handleButtonFilterCategory} style={{height:'35px',width:'170px'}}> 
            <img src='https://cdn-icons-png.flaticon.com/128/3841/3841533.png' height='25px' width='25px' style={{marginLeft:'-12px', marginRight:'10px'}}/>Category</div>
            <button className="btn btn-outline-primary ms-5 btn-sm" onClick={handleButtonFilterPrice}style={{height:'35px',width:'120px'}}> <img src='https://cdn-icons-png.flaticon.com/128/3841/3841533.png' height='25px' width='25px' style={{marginLeft:'-12px', marginRight:'10px', transform: 'rotate(90deg)'}}/>price</button>
          </div>
          {filterCategory &&
          <>
          <h6 className="text-secondary">Filter By Category</h6>
            <div className="d-flex flex-column">
          {categories?.map((c) => (
            <Checkbox
              key={c._id}
              onChange={(e) => handleFilter(e.target.checked, c._id)}
            >
              {c.name}
            </Checkbox>
          ))}

                   {categories?.map((c)=>(
                     <div className="form-check">
                          <input className="form-check-input" type="checkbox" defaultValue id="flexCheckDefault"
          checked={checked.includes(c._id)} onChange={(e) => handleFilter(e.target.checked, c._id)} />
                         <label className="form-check-label" htmlFor="flexCheckDefault" style={{fontSize:'13px'}}>
                             {c.name}
                         </label>
                     </div>
                 ))}
        </div>
          </>
        
          }
          
          {/* price filter */}
          {filterprice &&
          <>
          <h6 className="text-secondary mt-4">Filter By Price</h6>
          <div className="d-flex flex-column">
            {/* <Radio.Group onChange={(e) => setRadio(e.target.value)}>
              {Prices?.map((p) => (
                <div key={p._id}>
                  <Radio value={p.array}>{p.name}</Radio>
                </div>
              ))}
            </Radio.Group> */}
            {/* {Prices.map((p) => (
        <div key={p._id} className="form-check">
          <input
            type="radio"
            id={p.array}
            name="radiogroup"
            className="form-check-input"
            value={p.array}
            checked={radio === p.array}
            onChange={(e) => setRadio(e.target.value)}
          />
          <label htmlFor={p.array} className="form-check-label">
            {p.name}
          </label>
        </div>
      ))} */}
        {Prices.map((p) => (
        <div key={p._id} className="form-check">
          <input
            type="radio"
            id={p.array}
            name="radiogroup"
            className="form-check-input"
            value={p.array}
            checked={radio === p.array}
            onChange={(e) => setRadio(e.target.value)}
          />
          <label htmlFor={p.array} className="form-check-label"style={{fontSize:'16px'}}>
            {p.name}
          </label>
        </div>
      ))}
      <style>{`
        .form-check-input[type='radio']:checked {
          background-color: gray;
        }
      `}</style>
          </div>
          <div className="d-flex flex-column">
            <button   style={{width:'200px'}}
              className="btn btn-danger mt-3"
              onClick={() => window.location.reload()}
            >
              RESET FILTERS
            </button>
          </div>
          </>
          }
         
        </div>
        <div className="col-12 col-sm-12 col-md-9 col-lg-10">
          <hr />
               <h1 className="text-center mt-3">All Products</h1>
               <div className="d-flex flex-wrap ">
               {products?.map((p) => (
              <div className="card products_card m-2" style={{ width: "10rem" , height:'22rem', border:'none'}}>
                <img
                  src={`https://bablu-server.onrender.com/api/product-photo/${p._id}`}
                  className="card-img-top"
                  alt={p.name}
                  height='150px'
                  width='150px'
                />
                <div className="card-body">
                  <h6 className="card-title text-primary">{p.name}</h6>
                  <p className="card-text text-secondary">
                    {p.description.substring(0, 30)}...
                  </p>
                  <p style={{marginTop:'-13px', marginBottom:'-2px'}}>{p.price} Rs.</p>
                  <button class="btn btn-outline-primary btn-sm m-2 ms-1" style={{fontSize:'12px', zIndex:'1000'}} onClick={()=> navigate(`/product/${p.slug}`)}>More Details</button>
                  {/* <button class="btn btn-secondary ms-1" onClick={()=>{setCart([...cart, p])
                  toast.success('Item Added to cart')}}>ADD TO CART</button> */}
                   <button
                    className="btn btn-outline-secondary btn-sm ms-1"
                    style={{fontSize:'13px', zIndex:'1000'}}
                    onClick={() => {
                      setCart([...cart, p]);
                      localStorage.setItem(
                        "cart",
                        JSON.stringify([...cart, p])
                      );
                      toast.success("Item Added to cart");
                    }}
                  >
                    Add to cart
                  </button>
                </div>
              </div>
            ))}
          
          </div>
         
               <div className="m-2 p-3">
            {products && products.length < total && (
              <button
                className="btn btn-warning"
                onClick={(e) => {
                  e.preventDefault();
                  setPage(page + 1);
                }}
              >
                {loading ? "Loading ..." : "Loadmore"}
              </button>
            )}
          </div>
       
          
         
        </div>
      </div>
</div>

    </Layout>
  );
};

export default HomePage;